import React from "react"
import PropTypes from "prop-types"
import {
  Card,
  CardBody,
  Col,
  Form,
  Input,
  Label,
  Row,
  FormFeedback,
} from "reactstrap"
import * as Yup from "yup"
import { useFormik } from "formik"

const PaymentSettings = ({ onUpdate, onChangeSettings, settings }) => {
  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,
    initialValues: {
      gst: (settings && settings.gst) || "",
      minAmountIncurred: (settings && settings.minAmountIncurred) || "",
      maxDaysHeld: (settings && settings.maxDaysHeld) || "",
    },
    validationSchema: Yup.object({
      gst: Yup.string()
        .required("Please Enter Value")
        .matches(/^[0-9]+$/i, "Invalid value!"),
      minAmountIncurred: Yup.string()
        .required("Please Enter Value")
        .matches(/^[0-9]+$/i, "Invalid value!"),
      maxDaysHeld: Yup.string()
        .required("Please Enter Value")
        .matches(/^[0-9]+$/i, "Invalid value!"),
    }),
    onSubmit: values => {
      if (values) {
        const modifiedData = { ...settings }
        modifiedData["gst"] = values["gst"]
        modifiedData["minAmountIncurred"] = values["minAmountIncurred"]
        modifiedData["maxDaysHeld"] = values["maxDaysHeld"]
        onChangeSettings("paymentSettings", modifiedData)
      }
    },
  })

  return (
    <React.Fragment>
      <Card>
        <CardBody>
          <div className="mb-4 card-title">
            <i className="bx bx-dollar text-primary align-bottom font-size-24 me-2"></i>
            Payment Settings
          </div>
          <Form
            onSubmit={e => {
              e.preventDefault()
              validation.handleSubmit()
              return false
            }}
          >
            <Row>
              <Col md={4}>
                <div className="mb-3">
                  <Label className="form-label">GST*</Label>
                  <div className="input-group">
                    <Input
                      name="gst"
                      value={validation.values.gst || ""}
                      type="text"
                      className="form-control form-control"
                      style={{ textAlign: "right" }}
                      onChange={validation.handleChange}
                      onBlur={validation.handleBlur}
                      invalid={
                        validation.touched.gst && validation.errors.gst
                          ? true
                          : false
                      }
                    />
                    <button
                      type="button"
                      id=""
                      className="btn btn-border"
                      style={{
                        border: "1px solid #ced4da",
                        borderLeft: "1px solid #fff",
                      }}
                    >
                      %
                    </button>
                  </div>
                  {validation.touched.gst && validation.errors.gst ? (
                    <FormFeedback type="invalid">
                      {validation.errors.gst}
                    </FormFeedback>
                  ) : null}
                </div>
              </Col>
              <Col md={4}>
                <div className="mb-3">
                  <Label htmlFor="formrow-email-Input" className="form-label">
                    Min Amount Incurred*
                  </Label>
                  <Input
                    name="minAmountIncurred"
                    style={{ textAlign: "right" }}
                    value={validation.values.minAmountIncurred || ""}
                    className="form-control input-mask"
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    invalid={
                      validation.touched.minAmountIncurred &&
                      validation.errors.minAmountIncurred
                        ? true
                        : false
                    }
                  />
                  <span className="badgecount text-muted">
                    before auto billing
                  </span>
                  {validation.touched.minAmountIncurred &&
                  validation.errors.minAmountIncurred ? (
                    <FormFeedback type="invalid">
                      {validation.errors.minAmountIncurred}
                    </FormFeedback>
                  ) : null}
                </div>
              </Col>
              <Col md={4}>
                <div className="mb-3">
                  <Label className="form-label">Max Days Held*</Label>
                  <Input
                    name="maxDaysHeld"
                    value={validation.values.maxDaysHeld || ""}
                    type="text"
                    className="form-control form-control"
                    style={{ textAlign: "right" }}
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    invalid={
                      validation.touched.maxDaysHeld &&
                      validation.errors.maxDaysHeld
                        ? true
                        : false
                    }
                  />
                  <span className="badgecount text-muted">
                    before auto billing
                  </span>
                  {validation.touched.minAmountIncurred &&
                  validation.errors.minAmountIncurred ? (
                    <FormFeedback type="invalid">
                      {validation.errors.minAmountIncurred}
                    </FormFeedback>
                  ) : null}
                </div>
              </Col>
            </Row>
            <div className="mb-3"></div>
            <div>
              <button
                type="sumbit"
                //onClick={onUpdate}
                className="btn btn-primary w-md"
              >
                Update
              </button>
            </div>
          </Form>
        </CardBody>
      </Card>
    </React.Fragment>
  )
}
PaymentSettings.propTypes = {
  onUpdate: PropTypes.func,
  onChangeSettings: PropTypes.func,
  settings: PropTypes.any,
}
export default PaymentSettings
